import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  IconButton,
  Button,
  TextField,
  MenuItem,
  Select,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  FormControl,
  InputLabel,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { addServer, deleteServer, setSelectedServer } from '../../../../features/networkUndoSlice';

function ServerSelector() {
  const dispatch = useDispatch();
  const servers = useSelector((state) => state.networkUndo?.present?.servers || []);
  const selectedServer = useSelector((state) => state.networkUndo?.present?.selectedServer || 'http://localhost:8000');

  const [open, setOpen] = useState(false);
  const [newServer, setNewServer] = useState({ name: '', url: '' });

  const handleSelectChange = (event) => {
    dispatch(setSelectedServer(event.target.value));
  };

  const handleOpenModal = () => {
    setNewServer({ name: '', url: '' });
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleAddServer = () => {
    dispatch(addServer(newServer));
    setOpen(false);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setNewServer((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDeleteServer = (urlToDelete) => {
    dispatch(deleteServer(urlToDelete));
  };

  return (
    <Box display="flex" alignItems="center">
      <FormControl sx={{ my: 1 }} size="small">
        <InputLabel id="server-select">Server</InputLabel>
        <Select
          value={selectedServer}
          onChange={handleSelectChange}
          fullWidth
          label="Server"
          // Custom render method to show only the server info in the closed state,
          // while the open dropdown will show the full MenuItem with delete button
          renderValue={(selected) => {
            const server = servers.find((s) => s.url === selected);
            return server ? `${server.name} (${server.url})` : '';
          }}
        >
          <MenuItem value="" disabled>
            Select a server
          </MenuItem>
          {servers.map((server) => (
            <MenuItem
              key={server.url}
              value={server.url}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <span>{`${server.name} (${server.url})`}</span>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  handleDeleteServer(server.url);
                }}
                sx={{ ml: 1 }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <IconButton onClick={handleOpenModal} color="primary">
        <AddIcon />
      </IconButton>

      <Dialog open={open} onClose={handleCloseModal}>
        <DialogTitle>Add a New Server</DialogTitle>
        <DialogContent dividers>
          <TextField
            autoFocus
            margin="dense"
            name="name"
            label="Server Name"
            fullWidth
            value={newServer.name}
            onChange={handleInputChange}
          />
          <TextField
            margin="dense"
            name="url"
            label="Server URL"
            fullWidth
            value={newServer.url}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancel</Button>
          <Button onClick={handleAddServer} variant="contained">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ServerSelector;
